import { render, staticRenderFns } from "./PasswordResetPage.vue?vue&type=template&id=56a49b19&scoped=true&"
import script from "./PasswordResetPage.vue?vue&type=script&lang=js&"
export * from "./PasswordResetPage.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetPage.vue?vue&type=style&index=0&id=56a49b19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../.jenkins/workspace/DMSDashboardDeployLIVE/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a49b19",
  null
  
)

export default component.exports